export default __webpack_public_path__ + "img/BF_NOMA.ebec42e419f449072b0a929736624b65.jpg";